// Query keys centralizadas y jerárquicas del dominio license-application.
export const licenseApplicationKeys = {
  all: ["licenseapplication"],
  list: () => [...licenseApplicationKeys.all, "list"],
  vacationDays: () => [...licenseApplicationKeys.all, "vacation-days"],
  fieldsMetadata: () => [...licenseApplicationKeys.all, "fields-metadata"],
  supervisors: () => [...licenseApplicationKeys.all, "supervisors"],
};
